import { EmailTemplate, EmailTemplateCategory } from '@spike/email-marketing-model';
import { FunctionComponent } from 'react';
import EmailTemplateCard from './Card/EmailTemplateCard';
import styles from './EmailTemplatesList.module.scss';

interface EmailTemplateCategorySectionProps {
    category: EmailTemplateCategory | 'all';
    templates: EmailTemplate[];
    onSelectTemplate?: (template: EmailTemplate) => void;
    /** Required — forwarded straight to every Card. See `EmailTemplateCard`. */
    onPreviewTemplate: (template: EmailTemplate) => void;
}

const getCategoryTitle = (category: EmailTemplateCategory | 'all') => {
    switch (category) {
        case 'promotional':
            return 'Promotional';
        case 'seasonal':
            return 'Seasonal';
        case 'engagement':
            return 'Engagement';
        case 'system_default':
            return 'System Templates';
        case 'all':
            return 'All Templates';
        default:
            return category;
    }
};

const EmailTemplateCategorySection: FunctionComponent<EmailTemplateCategorySectionProps> = ({
    category,
    templates,
    onSelectTemplate,
    onPreviewTemplate
}) => {
    return (
        <div className={styles.categorySection}>
            <h3 className={styles.categoryTitle}>{getCategoryTitle(category)}</h3>

            <div className={styles.templatesGrid}>
                {templates.map(template => (
                    <EmailTemplateCard
                        key={template.id ?? template.uuid}
                        template={template}
                        onSelectTemplate={onSelectTemplate}
                        onPreviewTemplate={onPreviewTemplate}
                    />
                ))}
            </div>
        </div>
    );
};

export default EmailTemplateCategorySection;
